import React, { useEffect, useState } from 'react';

const InlinePdfViewer = ({ file, folderId, onClose }) => {
  const [loaded, setLoaded] = useState(false);
  const hasInfo = !!file && !!folderId;

  const fileId = file?.fileId || file?.file_id;
  const previewUrl = hasInfo
    ? `${process.env.REACT_APP_API_URL || 'https://fileshare-backend.couriertrackerinfo.workers.dev'}/api/preview/${folderId}/${fileId}`
    : '';
  const filename = file?.originalFilename || file?.original_filename || file?.filename || 'document.pdf';

  // Use stock Mozilla PDF.js viewer and hide the built-in filename (keep a clean toolbar)
  // Restore Mozilla PDF.js stock viewer. Keep parameters minimal to avoid duplicated filename headers.
  const pdfViewerUrl = hasInfo
    ? `https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(previewUrl)}#view=FitH&navpanes=0`
    : '';

  useEffect(() => {
    setLoaded(false);
    if (!pdfViewerUrl) return;
    // Preconnect to Mozilla viewer to speed up first paint
    const href = 'https://mozilla.github.io';
    const exists = document.querySelector(`link[rel="preconnect"][href="${href}"]`);
    if (!exists) {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = href;
      document.head.appendChild(link);
    }
  }, [pdfViewerUrl]);

  return (
    <div style={{
      backgroundColor: '#1a1d29',
      border: '1px solid #374151',
      borderRadius: '4px',
      margin: '8px 0',
      overflow: 'hidden'
    }}>
      {/* No separate close UI; handled by toggling the View button */}

      {/* Mozilla PDF.js Viewer */}
      <div style={{ height: '600px', position: 'relative' }}>
        {!loaded && (
          <div style={{
            position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
            backgroundColor: '#0f172a', borderBottom: '1px solid #1f2937'
          }}>
            <div style={{
              width: '28px', height: '28px', border: '3px solid #4b5563', borderTopColor: '#60a5fa',
              borderRadius: '50%', animation: 'spin 1s linear infinite'
            }}/>
            <style>{`@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`}</style>
          </div>
        )}
        {hasInfo && (
          <iframe
            src={pdfViewerUrl}
            style={{ width: '100%', height: '100%', border: 'none' }}
            title={`PDF Preview: ${filename}`}
            allow="fullscreen"
            onLoad={() => setLoaded(true)}
          />
        )}
      </div>
    </div>
  );
};

export default InlinePdfViewer; 